import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import sessionStorage from 'redux-persist/lib/storage/session';
import { RootState } from '@store/store';
import { IAsset } from '@modules/ContactManager/components/Tabs/components/Assets/interfaces';

interface DraftSlice {
  contact: {
    [id: string]: {
      asset: IAsset | null;
    }
  }
}

const initialState: DraftSlice = {
  contact: {}
};

export const draftSlice = createSlice({
  name: 'draft',
  initialState,
  reducers: {
    setAssetDraftData: (state, action: PayloadAction<{ contactId: string, data: IAsset | null }>) => {
      const { contactId, data } = action.payload;

      return {
        contact: {
          ...state.contact,
          [contactId]: {
            ...state.contact[contactId],
            asset: data
          }
        }
      };
    },
    removeAssetDraftData: (state, action: PayloadAction<{ contactId: string }>) => {
      const { contactId } = action.payload;

      state.contact[contactId].asset = null;
    },
  },
});

export const { setAssetDraftData, removeAssetDraftData } = draftSlice.actions;

export const getAssetDraftDataById = (id: string) => (state: RootState) => state.draft.contact[id]?.asset ?? null;

export const draftPersistConfig = {
  key: 'draft',
  storage: sessionStorage,
};